module.exports = __webpack_public_path__ + "img/670x290-BG-4.a60185fa.png";